export const GL_ACCOUNT_SUBSCRIPTION_ACTION = {
  SUBSCRIBE: 'SUBSCRIBE',
  UNSUBSCRIBE: 'UNSUBSCRIBE',
};

export const GL_ACCOUNT_ATTR_BOOLEAN_FIELDS = [
  'bank_type',
  'tax_account',
  'branch_account',
  'visible_to_branch',
  'in_cash_account',
  'negative_cash_flag',
  'petty_cash_flag',
  'posting_enabled',
];

export const GL_ACCOUNT_ATTR_TEXT_FIELDS = [
  'full_heirarchy_path',
  'normal_balance',
  'gl_node_class',
  'subledger_requirement',
  'role_alias',
  'posting_control',
];

export const GL_ACCOUNT_ATTR_ENUM_FIELDS = {
  account_type: 'COA_ACCOUNT_TYPE',
  income_stmt_line: 'COA_INC_ASSET_LINE',
  balance_sheet_line: 'COA_BS_ASSET_LINE',
};

export const GL_ACCOUNT_ATTR_FIELD_LABELS = {
  bank_type: 'Bank Type',
  tax_account: 'Tax Account',
  tax_percentage: 'Tax Percentage',
  branch_account: 'Branch Account',
  visible_to_branch: 'Visible To Branch',
  in_cash_account: 'In Cash Account',
  negative_cash_flag: 'Negative Cash Flag',
  petty_cash_flag: 'Petty Cash Flag',
  balance_sheet_line: 'Balance Sheet Line',
  account_type: 'Account Type',
  income_stmt_line: 'Income Statement Line',
  full_heirarchy_path: 'Full Hierarchy Path',
  normal_balance: 'Normal Balance',
  posting_enabled: 'Posting Enabled',
  gl_node_class: 'GL Node Class',
  subledger_requirement: 'Subledger Requirement',
  role_alias: 'Role Alias',
  posting_control: 'Posting Control',
};
